import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  REQUEST_ECO_LIST,
  REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST,
  REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST,
  REQUEST_ECO_ADD,
  REQUEST_ECO_DETAIL,
  REQUEST_ECO_UPDATE,
} from '../actions';
import {
  RequestEcoListSuccess,
  RequestEcoListError,
  RequestEcoSearchGeoCountryListSuccess,
  RequestEcoSearchGeoCountryListError,
  RequestEcoSearchHealthAgencyListSuccess,
  RequestEcoSearchHealthAgencyListError,
  RequestEcoAddSuccess,
  RequestEcoAddError,
  RequestEcoDetailSuccess,
  RequestEcoDetailError,
  RequestEcoUpdateSuccess,
  RequestEcoUpdateError
} from '../actions';
 
export function* watchRequestEcoList() {
  yield takeEvery(REQUEST_ECO_LIST, onRequestEcoList);
}

export function* watchRequestEcoSearchHealthAgencyList() {
  yield takeEvery(REQUEST_ECO_SEARCH_HEALTH_AGENCY_LIST, onRequestEcoSearchHealthAgencyList);
}

export function* watchRequestEcoSearchGeoCountryList() {
  yield takeEvery(REQUEST_ECO_SEARCH_GEO_COUNTRY_LIST, onRequestEcoSearchGeoCountryList);
}

export function* watchRequestEcoAdd() {
  yield takeEvery(REQUEST_ECO_ADD, onRequestEcoAdd);
}

export function* watchRequestEcoDetail() {
  yield takeEvery(REQUEST_ECO_DETAIL, onRequestEcoDetail);
}

export function* watchRequestEcoUpdate() {
  yield takeEvery(REQUEST_ECO_UPDATE, onRequestEcoUpdate);
}

const onRequestEcoListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_eco/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestEcoUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_eco/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}


const onRequestEcoAddAsync = async (data) => {
  console.log('onRequestEcoAddAsync')
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_eco/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onRequestEcoSearchGeoCountryListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/geo_country', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestEcoSearchHealthAgencyListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/health_agency', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestEcoDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_eco/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onRequestEcoList(data) {
  try {
    const response = yield call(onRequestEcoListAsync, data.payload);
    yield put(RequestEcoListSuccess(response.data));
  } catch (error) {
    yield put(RequestEcoListError(error));
  }
}

function* onRequestEcoSearchHealthAgencyList(data) {
  try {
    const response = yield call(onRequestEcoSearchHealthAgencyListAsync, data.payload);
    yield put(RequestEcoSearchHealthAgencyListSuccess(response.data));
  } catch (error) {
    yield put(RequestEcoSearchHealthAgencyListError(error));
  }
}

function* onRequestEcoSearchGeoCountryList(data) {
  try {
    const response = yield call(onRequestEcoSearchGeoCountryListAsync, data.payload);
    yield put(RequestEcoSearchGeoCountryListSuccess(response.data));
  } catch (error) {
    yield put(RequestEcoSearchGeoCountryListError(error));
  }
}

function* onRequestEcoAdd(data) {
  try {
      console.log('onRequestEcoAdd')
      const response = yield call(onRequestEcoAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestEcoAddSuccess(response.data));
  } catch (error) {
      yield put(RequestEcoAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onRequestEcoDetail(data) {
  try {
    const response = yield call(onRequestEcoDetailAsync, data.payload);
    yield put(RequestEcoDetailSuccess(response.data.data));
  } catch (error) {
    yield put(RequestEcoDetailError(error));
  }
}

function* onRequestEcoUpdate(data) {
  try {
      const response = yield call(onRequestEcoUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestEcoUpdateSuccess(response.data));
  } catch (error) {
      yield put(RequestEcoUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchRequestEcoList),
    fork(watchRequestEcoSearchGeoCountryList),
    fork(watchRequestEcoSearchHealthAgencyList),
    fork(watchRequestEcoAdd),
    fork(watchRequestEcoDetail),
    fork(watchRequestEcoUpdate),
  ]);
} 